<template>
    <base-widget>
        <class-list is-public></class-list>
    </base-widget>
</template>

<script>
    export default {
        name: 'ClassesWidget',
        components: {
            BaseWidget: () => import('@/components/controls/BaseWidget'),
            ClassList: () => import('@/components/dashboard/pages/Activities/ClassList')
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/dashboard/widgets/ClassesWidget.vue